<po-page-default>
  <form #registerForm="ngForm" #form="ngForm">
    <div class="po-row widget-row">
      <div class="po-xl-12">
        <p class="po-page-header-title">Alterar senha</p>
      </div>
      <po-widget class="po-lg-6">
        <po-input name="cpfCnpj" [(ngModel)]="cpfCnpj" p-clean [p-label]="labels.cpfCnpj" p-required="true"
          [p-show-required]="showRequired" [p-placeholder]="placeholders.cpfCnpj">
        </po-input>
        <po-email name="email" [(ngModel)]="email" [p-label]="labels.email" p-required="true"
          [p-show-required]="showRequired" [p-placeholder]="placeholders.email">
        </po-email>
        <div class="po-row buttons" style="justify-content: center;">
          <po-button class="po-md-4" p-label="Voltar" (p-click)="onBackLogin()">
          </po-button>
          <po-button class="po-md-4" p-label="Resetar senha" p-kind="primary" [p-disabled]="!form.valid"
            (p-click)="onResetPassword()">
          </po-button>
        </div>
      </po-widget>
      <img [src]="theme" alt="Imagem da empresa">
    </div>
  </form>
  <po-modal #modal [p-hide-close]="true" p-size="sm">
    <div class="po-xl-12">
      <p class="po-page-header-title">Nova senha</p>
    </div>
    <po-container>
      <div class="modal-body">
        <div class="mb-3">
            <div class="input-group">
              <po-input 
                name="autenticationCode"
                [(ngModel)]="autenticationCode"
                p-label="Código de confirmação"
                p-icon="ph ph-hash"
                [p-maxlength]="minlength"
                [p-minlength]="minlength"
                p-mask="999999"
                [p-no-autocomplete]="true"
                p-help="O código de confirmação foi enviado ao seu email.">
              </po-input>
              <po-password name="password"
                [(ngModel)]="password"
                [p-error-pattern]="errorPattern"
                [p-label]="labels.password"
                [p-minlength]="minlength"
                [p-pattern]="pattern"
                [p-placeholder]="placeholders.password"
                p-required="true"
                [p-show-required]="showRequired"
                [p-no-autocomplete]="true"
                (p-blur)="changeEvent('p-blur')"
                (p-change)="changeEvent('p-change')"
                (p-change-model)="changeEvent('p-change-model')"
                (p-enter)="changeEvent('p-enter')"
              >
              </po-password>
              <po-password name="confirmPassword"
                [(ngModel)]="confirmPassword"
                [p-error-pattern]="errorPattern"
                [p-label]="labels.confirmPassword"
                [p-minlength]="minlength"
                [p-pattern]="pattern"
                [p-placeholder]="placeholders.confirmPassword"
                p-required="true"
                [p-show-required]="showRequired"
                [p-no-autocomplete]="true"
                (p-blur)="changeEvent('p-blur')"
                (p-change)="changeEvent('p-change')"
                (p-change-model)="changeEvent('p-change-model')"
                (p-enter)="changeEvent('p-enter')"
              >
              </po-password>
            </div>
        </div>
      </div>
    </po-container>
    <po-modal-footer [p-disabled-align]="false">
      <div class="po-row buttons" style="justify-content: center;">
        <po-button p-kind="secundary" p-label="Cancelar" (p-click)="closeModal()">
        </po-button>
        <po-button p-kind="primary" p-label="Confirmar" [p-disabled]="!isFormValid()" (p-click)="confirmNewPassword()">
        </po-button>
      </div>
    </po-modal-footer>
  </po-modal>
</po-page-default>
